import { useNavigate, useParams } from "react-router";
import ReviewForm from "../modules/review/components/review-form";
import Container from "@/components/ui/container";

export default function CreateReviewPage() {
	const navigate = useNavigate();
	const { brandUrl } = useParams();

	const handleSuccess = () => {
		// Successfully created review
		navigate(`/${brandUrl}/reviews`);
	};

	const handleCancel = () => {
		navigate(`/${brandUrl}/reviews`);
	};

	return (
		<Container className="py-12">
			<div className="mb-8">
				<h1 className="text-xl font-semibold text-primary">Add Review</h1>
				<p className="mt-3 text-tertiary">Record feedback you've received via email, social media, or conversation.</p>
			</div>
			<ReviewForm onSuccess={handleSuccess} onCancel={handleCancel} />
		</Container>
	);
}
